export default __webpack_public_path__ + "static/media/main_info_data_02.af1afca8.png";